import React, { useState } from 'react';
import { CheckCircle2, Clock, Loader2, Phone, ShieldCheck } from 'lucide-react';
import { Input } from '../ui/Input';
import { Label } from '../ui/Label';
import { Textarea } from '../ui/Textarea';
import { services } from '../../data/services';
type Status = 'idle' | 'submitting' | 'success' | 'error';
export function QuoteSection() {
  const [status, setStatus] = useState<Status>('idle');
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setStatus('submitting');
    window.setTimeout(() => setStatus('success'), 900);
  };
  return <section id="quote" className="bg-white py-20 md:py-28" data-id="element-169" data-mp="10cirgrnaigcb">
      <div className="mx-auto max-w-7xl px-6" data-id="element-170" data-mp="10e3l8f1s5v94">
        <div className="overflow-hidden rounded-3xl border border-black/[0.07] bg-sand" data-id="element-171" data-mp="14edrztxecpp1">
          <div className="grid lg:grid-cols-[0.9fr_1.1fr]" data-id="element-172" data-mp="2upic4z6j20qg">
            <div className="bg-ink p-9 text-white md:p-12" data-id="element-173" data-mp="2unxjjf3rwrv8">
              <p className="text-xs font-semibold uppercase tracking-[0.16em] text-brand-light" data-id="element-174" data-mp="2yq2cebmedkgt">
                Free quote
              </p>
              <h2 className="mt-4 font-heading text-3xl font-semibold leading-tight tracking-tight sm:text-4xl" data-id="element-175" data-mp="1w87kqwnhm64">
                Let&apos;s get your project started
              </h2>
              <p className="mt-4 text-lg leading-relaxed text-white/70" data-id="element-176" data-mp="gn7b3nimpkiu">
                Tell us what you&apos;re working on and we&apos;ll get back to you
                within one business day with next steps and a clear estimate.
              </p>

              <ul className="mt-10 space-y-5 text-[15px] text-white/80" data-id="element-177" data-mp="3f3jmbm1mek4g">
                <li className="flex gap-3" data-id="element-178" data-mp="3tzraexg5g5p0">
                  <Clock className="mt-0.5 h-5 w-5 flex-none text-brand-light" aria-hidden="true" data-id="element-179" data-mp="3u1lvcbrf7xt3" />
                  Response within one business day
                </li>
                <li className="flex gap-3" data-id="element-180" data-mp="1990k4euipve2">
                  <ShieldCheck className="mt-0.5 h-5 w-5 flex-none text-brand-light" aria-hidden="true" data-id="element-181" data-mp="197yy5fbyrohk" />
                  Licensed, insured, and fully warrantied work
                </li>
                <li className="flex gap-3" data-id="element-182" data-mp="1bddq7ei4mqnu">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 flex-none text-brand-light" aria-hidden="true" data-id="element-183" data-mp="1gcqabrhm5jmq" />
                  Fixed quotes — the price we give is the price you pay
                </li>
              </ul>

              <a href="tel:+17205550142" className="mt-10 inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/10" data-id="element-184" data-mp="1qbfs7k9if42z">
                <Phone className="h-4 w-4" aria-hidden="true" data-id="element-185" data-mp="xk5v3cuu7d1e" />
                (720) 555-0142
              </a>
            </div>

            <div className="p-9 md:p-12" data-id="element-186" data-mp="17ctqc36658y0">
              {status === 'success' ? <div role="status" className="flex h-full flex-col items-start justify-center" data-id="element-187" data-mp="9wxpsuxes3zd">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-brand-tint text-brand" data-id="element-188" data-mp="eupqadc4cyf6">
                    <CheckCircle2 className="h-6 w-6" aria-hidden="true" data-id="element-189" data-mp="2s46bta6ig29q" />
                  </span>
                  <h3 className="mt-5 font-heading text-2xl font-semibold text-ink" data-id="element-190" data-mp="2o2krx4vk6nq1">
                    Thanks — your request is in.
                  </h3>
                  <p className="mt-3 max-w-md text-[15px] leading-relaxed text-ink-soft" data-id="element-191" data-mp="2e5g5d3xswq8p">
                    One of our project leads will reach out within one business
                    day. If it&apos;s urgent, give us a call at (720) 555-0142.
                  </p>
                  <button type="button" onClick={() => setStatus('idle')} className="mt-7 text-sm font-semibold text-brand underline-offset-4 hover:underline" data-id="element-192" data-mp="20eut3y2urejs">
                    Submit another request
                  </button>
                </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-193" data-mp="1lidkhem1se0x">
                  <div className="grid gap-5 sm:grid-cols-2" data-id="element-194" data-mp="3ljto42dxrt29">
                    <div className="space-y-2" data-id="element-195" data-mp="3qj6id87502ev">
                      <Label htmlFor="q-name" data-id="element-196" data-mp="3qhv42eg2fc9i">Full name</Label>
                      <Input id="q-name" name="name" required autoComplete="name" placeholder="Jane Doe" data-id="element-197" data-mp="3bujqk70bpi6r" />
                    </div>
                    <div className="space-y-2" data-id="element-198" data-mp="3gsbmdc439og8">
                      <Label htmlFor="q-phone" data-id="element-199" data-mp="3gr0jrfmdqmqp">Phone</Label>
                      <Input id="q-phone" name="phone" type="tel" required autoComplete="tel" placeholder="(720) 555-0142" data-id="element-200" data-mp="32s0rlxznrpps" />
                    </div>
                  </div>

                  <div className="grid gap-5 sm:grid-cols-2" data-id="element-201" data-mp="r41hfshukzct">
                    <div className="space-y-2" data-id="element-202" data-mp="r4kmi8meft9f">
                      <Label htmlFor="q-email" data-id="element-203" data-mp="w2vwcjcp23rn">Email</Label>
                      <Input id="q-email" name="email" type="email" required autoComplete="email" placeholder="jane@email.com" data-id="element-204" data-mp="w2cojvgrcvrc" />
                    </div>
                    <div className="space-y-2" data-id="element-205" data-mp="2qct2f5jw3hbx">
                      <Label htmlFor="q-city" data-id="element-206" data-mp="2lj88pppbx9ij">City</Label>
                      <Input id="q-city" name="city" placeholder="Parker, CO" data-id="element-207" data-mp="2zbo547nq69ah" />
                    </div>
                  </div>

                  <div className="space-y-2" data-id="element-208" data-mp="2vauh7eaa8uhl">
                    <Label htmlFor="q-service" data-id="element-209" data-mp="2vc5jtarzrw74">What do you need?</Label>
                    <select id="q-service" name="service" defaultValue="" className="h-9 w-full rounded-md border border-input bg-white px-3 text-sm text-ink shadow-sm outline-none focus-visible:ring-[3px] focus-visible:ring-brand/30" data-id="element-210" data-mp="398j5yx7h0lrx">
                      <option value="" disabled data-id="element-211" data-mp="39yzeoc0l4wsc">
                        Select a service
                      </option>
                      {services.map(service => <option key={service.id} value={service.id} data-id="element-212" data-mp="3eycavndcjg7l">
                          {service.title}
                        </option>)}
                      <option value="honey-do" data-id="element-213" data-mp="3nztlwrbwcrpf">Honey-Do List Special</option>
                      <option value="other" data-id="element-214" data-mp="3syddb799evp6">Something else</option>
                    </select>
                  </div>

                  <div className="space-y-2" data-id="element-215" data-mp="1qipd1o38ln3">
                    <Label htmlFor="q-details" data-id="element-216" data-mp="1p7jmwb313tc">Project details</Label>
                    <Textarea id="q-details" name="details" rows={4} placeholder="Tell us about the space, timeline, and anything else we should know." data-id="element-217" data-mp="6isn33vg2pzx" />
                  </div>

                  <button type="submit" disabled={status === 'submitting'} className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand px-7 py-4 text-base font-semibold text-white transition-colors hover:bg-brand-dark disabled:opacity-70 sm:w-auto" data-id="element-218" data-mp="kitmeew29pda">
                    {status === 'submitting' && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-219" data-mp="gnion8mxrs3m" />}
                    {status === 'submitting' ? 'Sending…' : 'Request my free quote'}
                  </button>
                  <p className="text-xs text-ink-soft/70" data-id="element-220" data-mp="18e5b4kk1hnko">
                    No obligation. We never share your information.
                  </p>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}